import $ from "jquery";
import CONFIG from "@bd-core/config";
import videojs from "video.js";
import bdjs from "@bd-core/bdjs";
import GameLogic from "@bd-core/game-logic";

export default class OutroVideo {
    constructor() {
        this.$outroFinish = $(".videobox.outro-finish");
        this.$outroTimeout = $(".videobox.outro-timeout");

        /** @type {import("video.js").VideoJsPlayer | null} */
        this.videoFinish = null;

        /** @type {import("video.js").VideoJsPlayer | null} */
        this.videoTimeout = null;
    }

    init() {
        let self = this;

        if ($("#outro-video-finish").length) {
            this.videoFinish = videojs("outro-video-finish", {
                controls: true,
                autoplay: false,
                preload: "auto",
            });

            this.videoFinish.on("loadeddata", () => {
                const tracks = this.videoFinish.textTracks();

                const track = tracks[0];
                if (!track) return;

                const cues = track.cues;
                if (cues.length === 0) return;

                const applyCueStyles = () => {
                    const activeCueElements = this.videoFinish
                        .el()
                        .querySelectorAll(".vjs-text-track-cue");
                    activeCueElements.forEach((el) => {
                        const htmlEl = /** @type {HTMLElement} */ (el);
                        const innerDiv = htmlEl.querySelector("div");
                        if (innerDiv) {
                            innerDiv.style.background = "transparent";
                            innerDiv.style.color = "#ffffff";
                            innerDiv.style.textShadow =
                                "0px 0px 12px rgba(0, 0, 0, 0.5), 0px 0px 12px rgba(0, 0, 0, 0.5), 0px 0px 12px rgba(0, 0, 0, 0.5), 0px 0px 12px rgba(0, 0, 0, 0.5), 0 0 12px rgba(0, 0, 0, 0.5)";
                        }
                    });
                };

                let timeupdateTimeout = null;
                this.videoFinish.on("timeupdate", () => {
                    if (timeupdateTimeout) {
                        clearTimeout(timeupdateTimeout);
                    }
                    timeupdateTimeout = setTimeout(() => {
                        applyCueStyles();
                    }, 100);
                });

                setTimeout(applyCueStyles, 100);

                for (let i = 0; i < cues.length; i++) {
                    const cue = cues[i];
                    cue.onenter = () => {
                        setTimeout(applyCueStyles, 0);
                    };
                }

                this.videoFinish.on("texttrackchange", () => {
                    applyCueStyles();
                });

                const textTrackDisplay = this.videoFinish
                    .el()
                    .querySelector(".vjs-text-track-display");
                if (textTrackDisplay) {
                    const observer = new MutationObserver(() => {
                        applyCueStyles();
                    });
                    observer.observe(textTrackDisplay, {
                        childList: true,
                        subtree: true,
                    });
                }
            });

            this.videoFinish.on("ended", () => {
                this.afterPlay();
            });

            this.videoFinish.on("error", function () {
                self.videoFinish = null;
            });
        }

        if ($("#outro-video-timeout").length) {
            this.videoTimeout = videojs("outro-video-timeout", {
                controls: true,
                autoplay: false,
                preload: "auto",
            });

            this.videoTimeout.on("ended", () => {
                this.afterPlay();
            });

            this.videoTimeout.on("error", function () {
                self.videoTimeout = null;
            });
        }
    }

    showVideo(isTimeout) {
        if (isTimeout) {
            this.$outroTimeout.addClass("is-open outro-video");
        } else {
            this.$outroFinish.addClass("is-open outro-video");
        }
    }

    afterPlay() {
        bdjs.showLoading();
        setTimeout(() => {
            //go to result page on video ended
            document.location.href = CONFIG.siteURL + "/mirror/";
        }, GameLogic.transisitonDuration);
    }
}
